import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { companyCamEndpoints } from '@/lib/api/endpoints';
import { companyCamKeys } from '@/lib/queryKeys';

export interface CompanyCamStatusResponse {
  /** False when the deployment has no CompanyCam credentials configured. */
  available: boolean;
  connected: boolean;
  status: string | null;
  externalAccountId: string | null;
  webhookRegistered: boolean;
  connectedAt: string | null;
  lastError: string | null;
  /**
   * Photos whose export failed and ran out of retry rounds.
   *
   * Non-zero means those photos are absent from CompanyCam and nothing will
   * try again — the card reports it because the alternative is silence.
   */
  failedExportCount: number;
}

/** GET /v2/integrations/companycam/status */
export function useCompanyCamStatus() {
  return useApiQuery<CompanyCamStatusResponse>({
    queryKey: companyCamKeys.status(),
    queryFn: () =>
      apiGet<CompanyCamStatusResponse>(
        operationsClient,
        companyCamEndpoints.status(),
      ),
  });
}
